import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent {

  //Type Value; solid, notification
  @Input() type: string;

  //Type Value; alert-dismissible
  @Input() dismissible: string;

  //Color Value; primary, secondary, success, danger, warning, info, light, dark
  @Input() color: string;

  @Input() text: string;

  @Input() closeButton: boolean = true;
}
